<template>
	<section class="about-box sec-padding">
		<div class="container">
			<div class="row">
				<div class="col-md-12 col-lg-6">
					<div class="row mb-10">
						<div class="col-md-12">
							<img class="full-width" v-lazy="data.master_img" alt="">
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 pr-5 pr-sm-15 mb-sm-10">
							<img class="full-width" v-lazy="data.slave_img1" alt="">
						</div>
						<div class="col-md-6 pl-5 pl-sm-15">
							<img class="full-width" v-lazy="data.slave_img2" alt="">
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-6">
					<div class="full-sec-content md-text-center mt-md-30" v-html="data.content"></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: "about-us",
		props: ['data']
	}
</script>



// WEBPACK FOOTER //
// src/components/home/AboutUs.vue